<template>
  <div class="container">
    <div class="left-box"></div>
    <div class="right-box">
      <div class="top-box">
        <div class="title-item hidden-sm hidden-xs">{{ title }}</div>
        <div class="breadcrumb-item">
          <ol class="breadcrumb" style="background-color: #fff">
            <template v-for="(item, idx) in breadCrumb" class="breadcrumb-div">
              <!-- <li><a href="#">Home</a></li>
              <li><a href="#">Library</a></li>
              <li class="active">Data</li> -->
              <li v-if="item.isActive">
                <router-link :to="item.path">{{ item.title }}</router-link>
              </li>
              <li v-else class="active">{{ item.title }}</li>
            </template>
          </ol>
        </div>
      </div>
      <div class="botton-box">
        <div class="botton-gray"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //标题
    title: {
      type: String,
      default: "中国植保双交会",
    },
    //面包屑导航
    breadCrumb: {
      type: Array,
      default() {
        return [
          {
            path: "/",
            title: "首页",
            isActive: true,
          },
          {
            path: "/plan/wholecountry",
            title: "凤凰植保会计划",
            isActive: true,
          },
          {
            path: "/plan/wholecountry",
            title: "中国植保双交会",
            isActive: false,
          },
        ];
      },
    },
  },
  methods: {},
};
</script>

<style  scoped>
.container {
  display: flex;
}
.container .left-box {
  margin: 5px 5px 0 0;
  width: 12px;
  height: 40px;
  background-color: #0076ce;
}
.container .right-box {
  width: 74%;
  display: flex;
  flex-direction: column;
}
.top-box {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  height: 43px;
}
.top-box .title-item {
  margin-top: 5px;
  font-size: 25px;
  color: #0076ce;
}
.top-box .breadcrumb-item {
  margin-top: 8px;
}
.botton-gray {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #0076ce 0%, #64b4e1 100%);
}
.breadcrumb-div {
  display: flex;
  flex-direction: row;
}
@media screen and (max-width: 768px) {
  .container .right-box {
    width: 100%;
  }
  .container .left-box {
    margin: 18px 5px 0 0;
    width: 8px;
    height: 26px;
    background-color: #0076ce;
  }
  .breadcrumb {
    padding: 11px 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NavLabel.vue